import { createSlice } from "@reduxjs/toolkit";
import { push } from "connected-react-router";

const initialState = {};

const insuranceToDisableSlice = createSlice({
  name: "insuranceToDisable",
  initialState,
  reducers: {
    setInsuranceToDisable(state, action) {
      state.insuranceToDisable = action.payload;
    }
  }
});

const { actions, reducer } = insuranceToDisableSlice;

export const { setInsuranceToDisable } = actions;

export const setInsuranceToDisableAction = (data) => async (dispatch) => {
  dispatch(setInsuranceToDisable(data));
};

export default reducer;
